import type { HTMLAttributes } from 'react';

import cn from '@/helper/cn';

import type { CardType } from '../constants/solutions';

type Props = HTMLAttributes<HTMLDivElement> & CardType;

const Card = ({ Icon, title, content, className, ...rest }: Props) => {
  return (
    <div
      className={cn(
        'flex flex-col gap-5 rounded-[3rem] bg-white px-9 pb-10 pt-7 md:p-12',
        className,
      )}
      {...rest}
    >
      {Icon && <Icon />}
      <h3 className="font-medium text-zinc-900 sm:text-xl lg:text-2xl">
        {title}
      </h3>
      <p className="text-xs text-zinc-600 sm:text-base lg:text-lg">{content}</p>
    </div>
  );
};

export default Card;
